import { compareAsc, parse } from 'date-fns';
import { PropertyType as PT, PropertyType, SortParams } from '..';

export const sortByName = (data: PT[], property: string): PT[] => {
	return data.slice().sort((a, b) => {
		const fieldA = (a[property] || '').trim();
		const fieldB = (b[property] || '').trim();
		if (fieldA === '' && fieldB === '') {
			return 0;
		}
		if (fieldA === '') {
			return -1;
		}
		if (fieldB === '') {
			return 1;
		}

		return fieldA.localeCompare(fieldB);
	});
};

export const sortNumbers = (data: PT[], property: string): PT[] => {
	return data.slice().sort((a, b) => {
		const numA = parseFloat(a[property] || 0);
		const numB = parseFloat(b[property] || 0);
		return numA - numB;
	});
};

export const sortDates = (data: PT[], property: string): PT[] => {
	return data.slice().sort((a, b) => {
		const dateA = parse(a[property] || '1970-01-01 00:00:00', 'yyyy-MM-dd HH:mm:ss', new Date());
		const dateB = parse(b[property] || '1970-01-01 00:00:00', 'yyyy-MM-dd HH:mm:ss', new Date());
		return compareAsc(dateA, dateB);
	});
};

export const sortData = (list: PropertyType[], sort: SortParams | null): PropertyType[] => {
	let result: PropertyType[] = [];
	if (sort) {
		switch (sort.type) {
			case 'number':
				result = sortNumbers(list, sort.field);
				break;
			case 'date':
				result = sortDates(list, sort.field);
				break;
			default:
				result = sortByName(list, sort.field);
				break;
		}
	} else {
		result = list;
	}

	return sort?.isAsc ? result : result.reverse();
};
